import {HttpClient} from '@angular/common/http';
import {ConfigService} from '../core/config.service';
import {Injectable} from '@angular/core';

interface RoomEnergySavings {
  room_id: string,
  timestamp: number,
  savings: number,
  totalkWh: number
}

@Injectable()
export class ReportService {
  constructor(private configService: ConfigService,
    private httpClient: HttpClient) {
  }

  getLocationEnergySavings(roomId: string, body: any): any {
    const url = this.configService.getEnergySavingsUrl() + '/energy-savings';
    return this.httpClient.post<RoomEnergySavings[]>(url, body).toPromise();
  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/reports/report.service.ts